// extracted by mini-css-extract-plugin
export default {"modalCustomizeContainer":"ModalCustomize_modalCustomizeContainer__fmbR+","itemsContainer":"ModalCustomize_itemsContainer__YsltS"};